import { render, staticRenderFns } from "./EntityRelatedWidget.vue?vue&type=template&id=63e996a4"
import script from "./EntityRelatedWidget.vue?vue&type=script&lang=js"
export * from "./EntityRelatedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports